import { Inject, Injectable, InjectionToken, inject } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';

export const PAYMENT_METHODS = new InjectionToken<PaymentMethodData[]>(
  'The methods used by Request Payment API',
  {
    factory: () => [{ supportedMethods: 'basic-card' }],
  },
);
declare global {
  interface Window {
    PaymentRequest: PaymentRequest;
  }
}
export const PAYMENT_REQUEST_SUPPORT = new InjectionToken<boolean>(
  'Is Payment Request Api supported?',
  {
    factory: () => !!inject(WINDOW).PaymentRequest,
  },
);

@Injectable({
  providedIn: 'root'
})
export class PaymentRequestApiService {

  constructor(
    @Inject(PAYMENT_REQUEST_SUPPORT) private readonly supported: boolean,
    @Inject(PAYMENT_METHODS)
    private readonly paymentMethods: PaymentMethodData[]) { }
  request(
    details: PaymentDetailsInit,
    methods: PaymentMethodData[] = this.paymentMethods): Promise<PaymentResponse> {
    if (!this.supported) {
      return Promise.reject(
        new Error('Payment Request is not supported in your browser'),
      );
    }

    const gateway = new PaymentRequest(methods, details);

    return gateway
      .canMakePayment()
      .then(canPay =>
        canPay
          ? gateway.show(details)
          : Promise.reject(
            new Error('Payment Request cannot make the payment'),
          ),
      );
  }
}
